/**
 * Which meal this is going to.
 *
 * The add screen had no way to say. It read the meal from the URL, and the only
 * link that set one was the diary's per-meal "Add" — so the raised + in the nav,
 * which is the primary action of the whole app, always landed on snack with no
 * way out of it. Everything logged from there was a snack.
 *
 * The default is the clock rather than a fixed value: at eight in the morning
 * the answer is breakfast almost every time, and being right by default is worth
 * more than being consistent. It is still four visible options, because "almost
 * every time" is not always and a wrong guess must cost one tap to correct.
 */

import type { Meal } from "@calorio/core";

const MEALS: { id: Meal; label: string }[] = [
  { id: "breakfast", label: "Breakfast" },
  { id: "lunch", label: "Lunch" },
  { id: "dinner", label: "Dinner" },
  { id: "snack", label: "Snack" },
];

/** The meal most likely meant right now, by local time. */
export function mealForHour(hour: number): Meal {
  if (hour < 11) return "breakfast";
  if (hour < 15) return "lunch";
  if (hour >= 17 && hour < 22) return "dinner";
  // Mid-afternoon and late night are genuinely snacks more often than not.
  return "snack";
}

export function MealPicker({ value, onChange }: { value: Meal; onChange: (meal: Meal) => void }) {
  return (
    <div className="meals" role="group" aria-label="Meal">
      {MEALS.map((meal) => (
        <button
          key={meal.id}
          type="button"
          className="meals__pill"
          aria-pressed={value === meal.id}
          onClick={() => onChange(meal.id)}
        >
          {meal.label}
        </button>
      ))}
    </div>
  );
}
